import Login from "../components/Login";

function LoginPage(prop) {
  return (
    <main>
      <h1>WIS Service</h1>
      <Login></Login>
    </main>
  );
}

export default LoginPage;
